import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    i: {
      text: 'Not be afraid to spend time alone and even be energized by it',
    },
    n: {
      text: 'Curious minds who think of ideas and possibilities of improving anything',
    },
    t: {
      text: 'Rely on rational facts when making decisions, withhold emotion',
    },
    j: {
      text: 'Accesses the world, making quick decision based on available facts',
    },
  },
  persons: [
    {
      slug: 'clinton',
      name: 'Hillary Clinton',
    },
    {
      slug: 'musk',
      name: 'Elon Musk',
    },
    {
      slug: 'tesla',
      name: 'Nikola Tesla',
    },
  ],
  advantages: [
    'Strategizing',
    'Innovative',
    'Determined',
    'Curious',
  ],
  disadvantages: [
    'Arrogant',
    'Socially awkward',
    'Perfectionist',
    'Workaholic',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'INTJs and friendships',
      text: 'INTJs can sometimes be seen by other people as not particularly warm or gregarious when they first meet. In some cases, they’re viewed as rude and arrogant. This is largely due to the INTJ having and knowing they have a high level of intellect. If they deem other people less intelligent, they sometimes treat them with less respect (sometimes without even knowing they’re doing so). They love to discuss concepts and ideas with others and when they meet like-minded people, they’re drawn to them and can build good friendships.',
    },
    {
      color: 'red',
      title: 'INTJs and work',
      text: 'People with the INTJ personality type excel at analyzing problems and then creating innovative solutions to them. This makes them uniquely suited to careers in fields such as medicine, science, I.T., engineering, and finance. However, they struggle in professions to do with customer service or having to deal too much with other people. INTJs love to work independently or in small teams where they have some say over the direction of the project that’s being worked on. When working in groups, they like every team member to be highly qualified and competent and aren’t afraid of dismissing other people’s ideas if they disagree with them.',
    },
    {
      color: 'mint',
      title: 'INTJs and romance',
      text: 'INTJs approach dating like a lot of other areas in their life, by using their analytical skills to carefully select a partner based on their list of requirements. When they find a partner, they’re known to be very loyal. Because they aren’t the best with their emotions, they’re sometimes seen by their partner as aloof, and they don’t usually place much emphasis on things they deem frivolous, like spontaneous romantic gestures.',
    },
  ],
  aboutTypeDescription:
    'The INTJ personality type is very rare, with only about 2% of the population having it. INTJs love to analyze problems and issues and then use their deep intellect to come up with innovative solutions—whether they be at home, work, or in any other area of their life. Most INTJs value their independence and can be quite uncomfortable in social situations as they struggle to deal with the emotions of others. When they do form friendships and relationships, they’re drawn to other highly intelligent people who they can discuss complex ideas and theories with.',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
          INTJs are Introverted because they like to spend time alone, Intuitive
          because they focus on ideas and concepts rather than facts and
          details, Thinking because they like to make decisions using their
          logical and reasoning skills, and Judging because they like to be
          organized rather than act spontaneously.
      </Text>
      <Text>
          INTJs have two main nicknames that they’re sometimes identified with:
          the Architect and the Mastermind. Both refer to their high level of
          intelligence and their ability to come up with solutions to problems.
      </Text>
    </TypographyPage>
  ),
}